<template>
    <main-content with_go_back_bar>
        <kt-panel v-if="usersListStatus === 'success' && findCatStatus === 'success'">
            <kt-panel-body >
                <form class="kt-form" @submit.prevent="update" >
                    <kt-form-section>
                        <kt-form-row>
                            <kt-col lg="6" md="6" sm="12">
                                <kt-form-group>
                                    <kt-form-label for="cat_name">
                                        {{ $t('label.cat_name') }}
                                    </kt-form-label>
                                    <kt-form-control
                                        dir="rtl"
                                        type="cat_name"
                                        name="cat_name"
                                        id="cat_name"
                                        v-model="categoryData.cat_name"
                                    ></kt-form-control>
                                </kt-form-group>
                            </kt-col>
                            <kt-col lg="6" md="6" sm="12">
                                <kt-form-group>
                                    <kt-form-label for="user_ids">
                                        {{ $t('label.user') }}
                                    </kt-form-label>
                                    <select
                                        id="user_ids"
                                        name="user_ids"
                                        class="form-control kt-selectpicker"
                                        v-model="categoryData.user_ids"
                                        multiple
                                    >
                                        <option
                                            v-bind:key="index"
                                            v-for="(user, index) in usersSelectable"
                                            :selected="isSelectedUser(user.value)"
                                            :value="user.value"
                                        >
                                            {{ user.name }} {{' - '}} {{user.phone}}
                                        </option>
                                    </select>
                                </kt-form-group>
                            </kt-col>
                        </kt-form-row>
                    </kt-form-section>

                    <kt-form-action class="mt-4">
                        <button class="btn btn-md btn-success btn-wide" type="submit" id="submit_btn">
                            {{ $t('btn.submit') }}
                        </button>
                    </kt-form-action>
                </form>
            </kt-panel-body>
        </kt-panel>
    </main-content>
</template>

<script>
import MainContent from "@/components/main-content";
import $ from "jquery";
import {KTApp} from "@/plugins/core/app";
import {userService} from "@/common/api.service";
import Vue from "vue";
import {KTUtil} from "@/plugins/core/util";
import {mapGetters} from "vuex";
import {i18n} from "@/plugins/i18n";

export default {
    components: {
        MainContent
    },
    data() {
        return {
            query: {}
        }
    },
    mounted() {
        this.afterMounted()
    },
    computed: {
        ...mapGetters('user', [
            'categoryData',
            'usersListStatus',
            'findCatStatus',
            'usersSelectable',
        ])
    },
    methods: {
        afterMounted() {
            if (this.usersListStatus !== 'success') {
                this.$store.dispatch('user/fetchForSelect').finally(() => {
                    this.$store.dispatch('user/fetchCategory', this.$route.params.hashid).finally(() => {
                        this.runSelectPicker()
                    })
                })
            } else {
                this.$store.dispatch('user/fetchCategory', this.$route.params.hashid).finally(() => {
                    this.runSelectPicker()
                })
            }
        },
        runSelectPicker() {
            $('.kt-selectpicker').selectpicker({
                size: 6,
                liveSearch: true,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
            })
        },
        update(e) {
            let form = $(e.target)
            let btn = $('#submit_btn')

            form.validate({
                ignore: ":hidden",

                rules: {
                    cat_name : {
                        required: true,
                    }
                },
            });

            if(!form.valid()) {
                return
            }

            let params = {
                cat_name: this.categoryData.cat_name,
                user_ids: this.categoryData.user_ids,
            }

            KTApp.progress(btn)
            userService.updateCategory(params, this.$route.params.hashid)
                .then(response => {
                    this.showMsg(form, 'success', response.data.message)
                })
                .catch(({response}) => {
                    if(response.data) {
                        form.validate().showErrors(response.data.data)
                    }
                    this.showMsg(form, 'danger', response.data.message)
                })
                .finally(() => {
                    KTApp.unprogress(btn)
                })
        },
        isSelectedUser(hashidd) {
            return Object.values(this.categoryData.user_ids).includes(hashidd)
        }
    }
}
</script>